const PLAY_URL='https://oyun.forin.com.tr/';
const INVITATION_TEXT='Kelimo’da kelimelerini kur, rakibinle yarış. Sen de oyna:';
function invitationData(){return {title:'Kelimo',text:INVITATION_TEXT,url:PLAY_URL};}
module.exports={PLAY_URL,INVITATION_TEXT,invitationData};
